/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { STYLES } from "config";
import { Card, CardBody, CardTitle, Button, Spinner, Alert } from "reactstrap";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import property24 from "../assets/property24.png";
import privateProperty from "../assets/private-property.png";
import apiWebsite from "../assets/api_images/Adobe Express - file.png";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { FirebaseContext } from "common";

const useStyles = makeStyles({
  root: {
    flexDirection: "row",
    display: "flex",
    width: "100%",
    height: "100%",
    backgroundColor: "#f8f9fa",
    padding: "0"
  },
  sidebar: {
    width: "250px",
    backgroundColor: "#2c3e50",
    color: "white",
    height: "100vh",
    position: "sticky",
    top: 0,
    overflowY: "auto",
    padding: "20px 0",
    boxShadow: "2px 0 10px rgba(0,0,0,0.1)"
  },
  sidebarItem: {
    padding: "12px 20px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    borderLeft: "4px solid transparent",
    "&:hover": {
      backgroundColor: "#34495e"
    }
  },
  sidebarItemActive: {
    padding: "12px 20px",
    cursor: "pointer",
    backgroundColor: "#3498db",
    borderLeft: "4px solid #fff",
    fontWeight: "600"
  },
  content: {
    flex: 1,
    padding: "20px",
    overflowY: "auto"
  },
  header: {
    width: "100%",
    maxWidth: "1200px",
    marginBottom: "30px",
    textAlign: "center"
  },
  pageTitle: {
    fontSize: "28px",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: "8px"
  },
  pageSubtitle: {
    fontSize: "16px",
    color: "#7f8c8d",
    marginBottom: "0"
  },
  Card: {
    width: "100%",
    padding: "20px",
    minWidth: "275px",
    border: "1px solid",
    borderColor: "#e0e0e0",
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
    marginBottom: "20px",
    backgroundColor: "#ffffff"
  },
  CardHeader: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2c3e50",
    margin: "0 0 15px 0",
    paddingBottom: "15px",
    position: "relative"
  },
  separator: {
    height: "2px",
    width: "100%",
    backgroundColor: "#e0e0e0",
    position: "absolute",
    bottom: "0",
    left: "0"
  },
  cardBody: {
    margin: "0",
    padding: "0"
  },
  imgContainer: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row"
  },
  twoColumnLayout: {
    display: "flex",
    gap: "20px",
    width: "100%",
    maxWidth: "1200px",
    "@media (max-width: 900px)": {
      flexDirection: "column"
    }
  },
  column: {
    flex: "1",
    minWidth: "0"
  },
  detailsRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 15px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
    marginBottom: "8px"
  },

  PublishCol: {
    borderWidth: "1px",
    borderColor: "#e0e0e09f",
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "12px 15px",
    borderRadius: "6px",
    marginBottom: "8px",
    flexDirection: "column"
  },

  detailsRowAlt: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 15px",
    backgroundColor: "#ffffff",
    borderRadius: "6px",
    marginBottom: "8px",
    border: "1px solid #f1f1f1"
  },
  verticalDetails: {
    width: "100%",
    padding: "15px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
    marginBottom: "10px"
  },
  verticalDetailsAlt: {
    width: "100%",
    padding: "15px",
    backgroundColor: "#ffffff",
    borderRadius: "6px",
    marginBottom: "10px",
    border: "1px solid #f1f1f1"
  },
  InfoDescriptionText: {
    width: "50%",
    color: "#2c3e50",
    fontSize: "14px",
    fontWeight: "600",
    margin: "0"
  },
  InfoText: {
    width: "50%",
    color: "#2c3e50",
    fontSize: "14px",
    fontWeight: "400",
    margin: "0",
    textAlign: "right"
  },
  InfoDescriptionTextVertical: {
    color: "#2c3e50",
    fontSize: "14px",
    fontWeight: "600",
    margin: "0 0 8px 0"
  },
  InfoTextVertical: {
    color: "#2c3e50",
    fontSize: "14px",
    fontWeight: "400",
    margin: "0",
    lineHeight: "1.5"
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#2c3e50",
    margin: "20px 0 10px 0",
    paddingBottom: "8px",
    borderBottom: "1px solid #e0e0e0"
  },
  sectionContainer: {
    scrollMarginTop: "20px"
  },

  syncButton: {
    width: "100%",
    marginTop: "10px",
    backgroundColor: "#3498db",
    border: "none",
    "&:hover": {
      backgroundColor: "#2980b9"
    },
    "&:disabled": {
      backgroundColor: "#bdc3c7"
    }
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 10,
    flexDirection: "row"
  }
});
function PropertyPublishDisplay({ listingData, setListingData }) {
  const styles = useStyles();
  const dispatch = useDispatch();
  const { api } = useContext(FirebaseContext);

  const {
    syncTop24,
    syncToPP,
    syncToWebsite,
    publishto24prop,
    clearPublishErrors,
    publishToprivateprop,
    updatePrivatePropStatus
  } = api;

  // Redux state for publish reducer
  const publishReducer = useSelector((state) => state.publishdata);
  const tokenManagementReducer = useSelector((state) => state.tokendata.token.token);
  // Local state for feedback
  const [syncMessage, setSyncMessage] = useState(null);
  const [syncingPortal, setSyncingPortal] = useState(null); // Track which portal is syncing
  const [ppStatusChange, setppStatusChange] = useState(false); // Track which portal is syncing

  // Sync handlers
  const handleSyncP24 = () => {
    //   dispatch(firebaseApi.syncTop24(listingData));

    setSyncingPortal("property24");
    console.log('listingData', listingData);
    dispatch(publishto24prop(listingData, listingData.userdetials.agentId));
  };

  const handleSyncPP = () => {
    setSyncingPortal("privateProperty");

    console.log('listingData', listingData)

    if (ppStatusChange) {
      dispatch(updatePrivatePropStatus(listingData, tokenManagementReducer));
    }
    dispatch(publishToprivateprop(listingData, tokenManagementReducer));
    setppStatusChange(false)
  };

  const handleSyncWebsite = () => {
    setSyncingPortal("website");
    dispatch(syncToWebsite(listingData));
  };

  // Error and success handling
  useEffect(() => {
    console.log(
      "Object.keys(listingData)",
      Object.keys(listingData ? listingData : {})
    );

    if (publishReducer.completed && publishReducer.success) {
      setSyncMessage({ type: "success", text: "Sync successful! ✅" });
      setSyncingPortal(null);

      if (publishReducer.portal === "privateProperty") {
        setListingData({
          ...listingData,
          syndicateFlags: {
            ...listingData.syndicateFlags,
            privateProperty: true
          }
        });
      }

      if (publishReducer.portal === "property24") {
        setListingData({
          ...listingData,
          syndicateFlags: {
            ...listingData.syndicateFlags,
            property24: true
          }
        });
      }



      setTimeout(() => setSyncMessage(null), 3000);
      dispatch(clearPublishErrors());
    }

    if (!publishReducer.success && publishReducer.error.flag) {
      console.log("publishReducer.error.msg ", publishReducer.error.msg);
      setSyncMessage({
        type: "danger",
        text: publishReducer.error.msg || "Sync failed."
      });
      setSyncingPortal(null);
      setTimeout(() => setSyncMessage(null), 4000);
    }
  }, [publishReducer]);


  const statusMapping = {
    // -------------------------------
    // Active on the market
    // -------------------------------
    Active: "active",
    NewListing: "active",
    BackOnMarket: "active",
    Extended: "active",
    RaisedPrice: "active",
    ReducedPrice: "active",
    ForSale: "active",
    ToLet: "active",

    // -------------------------------
    // Listed but not currently active / pending
    // -------------------------------
    PendingOffer: "warning",
    Pending: "warning",
    Rented: "warning",
    Withdrawn: "warning",
    CancelledSale: "warning",
    Expired: "warning",
    Cancelled: "warning",

    // -------------------------------
    // No longer available / closed / completed
    // -------------------------------
    Sold: "warning",
    Inactive: "warning",
    Archived: "warning",

    // -------------------------------
    // Fallback (optional)
    // -------------------------------
    Unknown: "error",
  };


  const renderStatusDisplay = (statusKey, isListed, portalType, error = null) => {
    const isSyncing = syncingPortal === portalType;
    const isSynced = publishReducer.success && syncingPortal === portalType;
    const hasError = error && publishReducer.error.flag && syncingPortal === portalType;

    let statusCategory;

    if (hasError) {
      statusCategory = "error";
    } else if (!statusKey) {
      statusCategory = "notListed";
    } else if (isListed && !statusKey) {
      statusCategory = "noStatus";
    } else {
      statusCategory = statusMapping[statusKey] || "warning";
    }


    // Icon + color mapping
    const iconMap = {
      active: { icon: "✔", color: "#27ae60", title: "Active on market" },
      warning: { icon: "!", color: "#f39c12", title: "Listed but not active" },
      noStatus: { icon: "!", color: "#f39c12", title: "Listed but no Status Found" },
      error: { icon: "!", color: "#e74c3c", title: "Error publishing" },
      notListed: { icon: "✖", color: "#e74c3c", title: "Not listed" }
    };

    // If syncing or synced, override icons
    if (isSyncing) return <span style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 28,
      height: 28,
      borderRadius: "50%",
      background: "#f39c12",
      color: "#fff",
      fontWeight: "bold",
      fontSize: 18
    }} title="Syncing...">⏳</span>;

    if (isSynced) return <span style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 28,
      height: 28,
      borderRadius: "50%",
      background: "#27ae60",
      color: "#fff",
      fontWeight: "bold",
      fontSize: 18
    }} title="Synced successfully">✅</span>;

    const { icon, color, title } = iconMap[statusCategory];

    return <span style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 28,
      height: 28,
      borderRadius: "50%",
      background: color,
      color: "#fff",
      fontWeight: "bold",
      fontSize: 18
    }} title={`${title} (${statusKey})`}>{icon}</span>;
  };



  const renderSyncStatusDisplay = (active, portalType, error = null) => {
    const isActive = !!active;
    const isSyncing = syncingPortal === portalType;
    const isSynced = publishReducer.success && syncingPortal === portalType;

    // Check if there's an error for this specific portal
    const hasError = error && publishReducer.error.flag && syncingPortal === portalType;

    if (hasError) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: "#e74c3c",
              color: "#fff",
              fontWeight: "bold",
              fontSize: 18
            }}
            title="Error - Click for details"
          >
            ❗
          </span>
          <span
            style={{
              fontSize: "12px",
              color: "#e74c3c",
              fontWeight: "500"
            }}
          >
            Error
          </span>
        </div>
      );
    }

    if (isSyncing) {
      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 28,
            height: 28,
            borderRadius: "50%",
            background: "#f39c12",
            color: "#fff",
            fontWeight: "bold",
            fontSize: 18
          }}
          title="Syncing..."
        >
          ⏳
        </span>
      );
    }

    if (isSynced) {
      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 28,
            height: 28,
            borderRadius: "50%",
            background: "#27ae60",
            color: "#fff",
            fontWeight: "bold",
            fontSize: 18
          }}
          title="Synced Successfully"
        >
          ✅
        </span>
      );
    }

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 28,
          height: 28,
          borderRadius: "50%",
          background: isActive ? "#27ae60" : "#e74c3c",
          color: "#fff",
          fontWeight: "bold",
          fontSize: 18
        }}
        title={isActive ? "Synced" : "Not Synced"}
      >
        {isActive ? "✔" : "✖"}
      </span>
    );
  };




  const handleExpiryDateChange = (portalType, newDate) => {
    // Update the listing data with the new expiry date

    if (portalType === "property24") {
      setListingData({
        ...listingData,
        P24expiryDate: newDate,
        syndicateFlags: {
          ...listingData.syndicateFlags,
          property24: false
        }
      });
    }


    if (portalType === "privateProperty") {
      setListingData({
        ...listingData,
        PPexpiryDate: newDate,
        syndicateFlags: {
          ...listingData.syndicateFlags,
          privateProperty: false
        }
      });
    }

    // You can add API calls here to update the expiry date on the backend
    console.log(`Updating ${portalType} expiry date to: ${newDate}`);
  };


  const renderExpiryDateSelector = (currentDate, portalType) => {
    return (
      <input
        type="date"
        value={currentDate || ''}
        onChange={(e) => handleExpiryDateChange(portalType, e.target.value)}
        style={{
          padding: "4px 8px",
          borderRadius: "4px",
          border: "1px solid #ddd",
          fontSize: "12px",
          backgroundColor: "#fff",
          cursor: "pointer",
          minWidth: "140px"
        }}
        onClick={(e) => e.stopPropagation()} // Prevent event bubbling
      />
    );
  };


  const renderStatusSelector = (status, portalType) => {


    return (
      <select
        value={portalType === "property24" ? status || "Withdrawn" : portalType === "privateProperty" ? status || "ForSale" : "Active"}
        onChange={(e) => handleStatusChange(portalType, e.target.value)}
        style={{
          padding: "4px 8px",
          borderRadius: "4px",
          border: "1px solid #ddd",
          fontSize: "12px",
          backgroundColor: "#fff",
          cursor: "pointer",
          minWidth: "80px"
        }}
        onClick={(e) => e.stopPropagation()} // Prevent event bubbling
      >
        {portalType === "property24" && (
          <>

            {(!moment(listingData.startPublishing).isBefore(moment().subtract(7, 'days')) || status === "NewListing") && (
              <option value="NewListing">New Listing</option>
            )
            }

            <option value="Active">Active</option>

            {(listingData.type === "sale" || listingData.type.includes("For Sale")) && (
              <>
                <option value="Pending">Pending</option>
                <option value="Sold">Sold</option>
                <option value="CancelledSale">Cancelled Sale</option>
              </>
            )
            }

            {(listingData.type === "tolet" || listingData.type.includes("To Let")) && (
              <>
                <option value="Rented">Rented</option>
              </>
            )
            }

            {(status === "Expired") && (
              <>
                <option value="Expired">Expired</option>
              </>
            )
            }

            <option value="BackOnMarket">Back On Market</option>
            <option value="Extended">Extended</option>
            <option value="Withdrawn">Withdrawn</option>
            <option value="RaisedPrice">Raised Price</option>
            <option value="ReducedPrice">Reduced Price</option>
            <option value="Cancelled">Cancelled</option>
          </>)}


        {portalType === "privateProperty" && (
          <>


            {(listingData.type === "sale" || listingData.type.includes("For Sale")) && (
              <>
                <option value="ForSale">For Sale</option>
                <option value="PendingOffer">Pending Offer</option>
                <option value="Sold">Sold</option>
              </>
            )
            }

            {(listingData.type === "tolet" || listingData.type.includes("To Let")) && (
              <>
                <option value="ToLet">To Let</option>
              </>
            )
            }

            <option value="Inactive">Inactive</option>
            <option value="Archived">Archived</option>
          </>)}

      </select>
    );
  };

  // Add this function to handle status changes
  const handleStatusChange = (portalType, newStatus) => {
    const isActive = newStatus === "active";

    // Update the listing data with the new status


    if (portalType === "property24") {
      setListingData({
        ...listingData,
        P24Status: newStatus,
        syndicateFlags: {
          ...listingData.syndicateFlags,
          property24: false
        }
      });
    }


    if (portalType === "privateProperty") {
      setppStatusChange(true);
      setListingData({
        ...listingData,
        PPStatus: newStatus,
        syndicateFlags: {
          ...listingData.syndicateFlags,
          privateProperty: false
        }
      });
    }
    // You can add API calls here to update the status on the backend
    console.log(`Updating ${portalType} status to: ${newStatus}`);
  };



  return (
    <div className={styles.root}>
      <div className={styles.content}>
        {/* Feedback message */}
        {syncMessage && (
          <Alert color={syncMessage.type} style={{ marginBottom: 20 }}>
            {syncMessage.text}
          </Alert>
        )}

        {/* Record Details Section */}
        <div id="record" className={styles.sectionContainer}>
          <Card className={styles.Card}>
            <CardTitle className={styles.CardHeader}>
              Portals
              <div className={styles.separator} />
            </CardTitle>

            <CardBody className={styles.cardBody}>
              <div className={styles.imgContainer}>
                {/* Property24 Card */}
                <div
                  className={styles.PublishCol}
                  style={{ position: "relative" }}
                >
                  <a
                    href={
                      listingData?.publishedProp24
                        ? `https://www.property24.com/for-sale/search?SearchText=${listingData?.ListingId}`
                        : undefined
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={property24}
                      alt="Property 24"
                      className={styles.propertyImage}
                      style={{ width: "100%", display: "block" }}
                    />
                  </a>

                  <div className={styles.detailsRowAlt}>
                    <p className={styles.InfoDescriptionText}>Published</p>
                    <p className={styles.InfoText}>
                      {renderStatusDisplay(listingData?.P24Status, listingData?.publishedProp24, "property24", publishReducer.error.msg)}
                    </p>
                  </div>


                  {listingData?.publishedProp24 && (
                    <>
                      <div className={styles.detailsRowAlt}>
                        <p className={styles.InfoDescriptionText}>Synced</p>
                        <p className={styles.InfoText}>
                          {renderSyncStatusDisplay(
                            listingData?.syndicateFlags?.property24,
                            "property24"
                          )}
                        </p>
                      </div>


                      <div className={styles.detailsRowAlt}>
                        <p className={styles.InfoDescriptionText}>Status</p>
                        <p className={styles.InfoText}>
                          {renderStatusSelector(
                            listingData?.P24Status,
                            "property24"
                          )}
                        </p>
                      </div>

                      <div className={styles.detailsRow}>
                        <p className={styles.InfoDescriptionText}>Expires</p>
                        <p className={styles.InfoText}>
                          {renderExpiryDateSelector(listingData?.P24expiryDate ?? listingData?.expiryDate, "property24")}
                        </p>
                      </div>
                    </>
                  )}

                  {/* Sync Button for Property24 */}
                  {!listingData?.syndicateFlags?.property24 && (
                    <div style={{ marginTop: "10px", padding: "10px" }}>
                      <Button
                        color="primary"
                        size="sm"
                        style={{ width: "100%", height: "35px" }}
                        onClick={handleSyncP24}
                        disabled={
                          publishReducer.loading &&
                          syncingPortal === "property24"
                        }
                      >
                        {publishReducer.loading &&
                          syncingPortal === "property24" ? (
                          <Spinner size="sm" />
                        ) : (
                          "Sync Property24"
                        )}
                      </Button>
                    </div>
                  )}
                </div>

                {/* Private Property Card */}
                <div
                  className={styles.PublishCol}
                  style={{ position: "relative" }}
                >
                  <a
                    href={
                      listingData?.publishedPP
                        ? `https://privateproperty.co.za/${listingData?.ListingPPId}`
                        : undefined
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={privateProperty}
                      alt="Private Property"
                      className={styles.propertyImage}
                      style={{ width: "100%", display: "block" }}
                    />
                  </a>

                  <div className={styles.detailsRowAlt}>
                    <p className={styles.InfoDescriptionText}>Published</p>
                    <p className={styles.InfoText}>
                      {renderStatusDisplay(
                        listingData?.PPStatus,
                        listingData?.publishedPP,
                        "privateProperty",
                        publishReducer.error.msg
                      )}
                    </p>
                  </div>

                  {listingData?.publishedPP && (
                    <>
                      <div className={styles.detailsRowAlt}>
                        <p className={styles.InfoDescriptionText}>Synced</p>
                        <p className={styles.InfoText}>
                          {renderSyncStatusDisplay(
                            listingData?.syndicateFlags?.privateProperty,
                            "privateProperty",
                            publishReducer.error.msg
                          )}
                        </p>
                      </div>


                      <div className={styles.detailsRowAlt}>
                        <p className={styles.InfoDescriptionText}>Status</p>
                        <p className={styles.InfoText}>
                          {renderStatusSelector(
                            listingData?.PPStatus,
                            "privateProperty"
                          )}
                        </p>
                      </div>


                      <div className={styles.detailsRow}>
                        <p className={styles.InfoDescriptionText}>Expires</p>
                        <p className={styles.InfoText}>
                          {renderExpiryDateSelector(listingData.PPexpiryDate ?? listingData?.expiryDate, "property24")}
                        </p>
                      </div>
                    </>
                  )}

                  {/* Sync Button for Private Property */}

                  {!listingData?.syndicateFlags?.privateProperty && (<div style={{ marginTop: "10px", padding: "10px" }}>
                    <Button
                      color="primary"
                      size="sm"
                      style={{ width: "100%", height: "35px" }}
                      onClick={handleSyncPP}
                      disabled={
                        publishReducer.loading &&
                        syncingPortal === "privateProperty"
                      }
                    >
                      {publishReducer.loading &&
                        syncingPortal === "privateProperty" ? (
                        <Spinner size="sm" />
                      ) : (
                        "Sync Private Property"
                      )}
                    </Button>
                  </div>)}
                </div>

                {/* API Website Card */}
                <div
                  className={styles.PublishCol}
                  style={{ position: "relative" }}
                >
                  <a
                    href={
                      listingData?.publishedAPIWeb
                        ? `https://api-prop.plum.systems/index.php/properties/category-blog/${listingData?.selectedArea?.wsParentId}/${listingData?.selectedArea?.wsCatId}-${listingData?.suburbId}/${listingData?.wsListingId}-${listingData?.web_Ref_No}`
                        : undefined
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >

                    <img
                      src={apiWebsite}
                      alt="API Website"
                      className={styles.propertyImage}
                      style={{ width: "100%", display: "block" }}
                    />
                  </a>
                  <div className={styles.detailsRowAlt}>
                    <p className={styles.InfoDescriptionText}>Published</p>
                    <p className={styles.InfoText}>
                      {renderStatusDisplay(listingData?.publishedAPIWeb, "website")}
                    </p>
                  </div>
                  {listingData?.publishedAPIWeb && (
                    <>
                      <div className={styles.detailsRowAlt}>
                        <p className={styles.InfoDescriptionText}>Status</p>
                        <p className={styles.InfoText}>
                          {renderSyncStatusDisplay(
                            listingData?.syndicateFlags?.website,
                            "website",
                            publishReducer.error.msg
                          )}
                        </p>
                      </div>

                      <div className={styles.detailsRow}>
                        <p className={styles.InfoDescriptionText}>Expires</p>
                        <p className={styles.InfoText}>
                          {renderExpiryDateSelector(listingData?.expiryDate, "property24")}
                        </p>
                      </div>
                    </>
                  )}

                  {/* Sync Button for API Website */}
                  {!listingData?.syndicateFlags?.website && (<div style={{ marginTop: "10px", padding: "10px" }}>
                    <Button
                      color="primary"
                      size="sm"
                      style={{ width: "100%", height: "35px" }}
                      onClick={handleSyncWebsite}
                      disabled={
                        publishReducer.loading && syncingPortal === "website"
                      }
                    >
                      {publishReducer.loading && syncingPortal === "website" ? (
                        <Spinner size="sm" />
                      ) : (
                        "Sync API Website"
                      )}
                    </Button>
                  </div>)}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default PropertyPublishDisplay;
